export default (document.location.host.indexOf('stg')!==-1?
        process.env.VUE_APP_LMP_API.replace('//','//stg.'):
        process.env.VUE_APP_LMP_API
)
